import React from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import Moment from '../../../components/utils/Moment';
import PatientAlerts from './PatientAlerts';
import { getAlerts } from '../utils/alerts';

export default class VisitNotesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pageSize: 25, page: 0 };
  }

  selectNote = note => this.props.selectNote(note);

  render() {
    const { data, isLoading, limits, selected, title } = this.props;
    const { page } = this.state;
    const pages = data ? Math.ceil(data.total / this.state.pageSize) : 0;
    const canPrevious = pages && page > 0;
    const canNext = pages && page + 1 < pages;
    return (
      <Dropdown className="btn-group" id="visit-notes-list-mobile">
        <Dropdown.Toggle className="btn dropdown-toggle">
          <i className="fa fa-list" /> {title} List
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {data &&
            data.list &&
            data.list.map(item => {
              return (
                <MenuItem key={item.visitNoteID} onClick={() => this.selectNote(item)} className={selected && selected.visitNoteID === item.visitNoteID ? 'active':''}>
                  <div className="notes-mobile-list-item">
                    <strong>{item.visitNoteID}</strong>
                    <div>
                      <Moment date={item.dateOfService} format="MM/DD/YYYY" />
                    </div>
                    <div className="alerts">
                      {item.isFollowUp && <span className="label label-info">F/U</span>}
                      {item.isReviewed && <span className="label label-default">Reviewed</span>}
                      {item.isResolved && <span className="label label-success">Resolved</span>}
                    </div>
                    <div className="alerts">
                      <PatientAlerts alerts={getAlerts(item, limits)} />
                    </div>
                  </div>
                </MenuItem>
              );
            })}
          {data &&
            data.list && (
              <MenuItem className="text-center">
                <div className="btn-group">
                  <button className="btn btn-default" disabled={!canPrevious}>
                    &laquo; Prev
                  </button>
                  <button className="btn btn-default" disabled={!canNext}>
                    Next &raquo;
                  </button>
                </div>
              </MenuItem>
            )}
          {isLoading && <div className="text-center">Loading&hellip;</div>}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/VisitNotesListMobile.js